// extracted by mini-css-extract-plugin
export var navBarShadow = "navbar-module--navBarShadow--d9872";
export var navbarContainter = "navbar-module--navbarContainter--76725";
export var stars = "navbar-module--stars--05efa";
export var starsContainer = "navbar-module--starsContainer--2dfd2";